(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("mggp-player"));
	else if(typeof define === 'function' && define.amd)
		define(["mggp-player"], factory);
	else if(typeof exports === 'object')
		exports["mggp-plugin-wss"] = factory(require("mggp-player"));
	else
		root["mggp-plugin-wss"] = factory(root["mggp-player"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE_mggp_player__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "./src/mggp-plugin-wss.js");
/******/ })
/************************************************************************/
/******/ ({

/***/ "./src/mggp-plugin-wss.js":
/*!********************************!*\
  !*** ./src/mggp-plugin-wss.js ***!
  \********************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _mggpPlayer = __webpack_require__(/*! mggp-player */ "mggp-player");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @class MggpPluginWss
 */
var MggpPluginWss = function (_Plugin) {
  _inherits(MggpPluginWss, _Plugin);

  /**
   *
   */
  function MggpPluginWss() {
    var _ref;

    for (var _len = arguments.length, params = Array(_len), _key = 0; _key < _len; _key++) {
      params[_key] = arguments[_key];
    }

    _classCallCheck(this, MggpPluginWss);

    var _this = _possibleConstructorReturn(this, (_ref = MggpPluginWss.__proto__ || Object.getPrototypeOf(MggpPluginWss)).call.apply(_ref, [this].concat(params)));

    _this.IGNORE_STOP_EVENT = 'wss:ignore:stopEvent';
    _this.IGNORE_VIDEOINFO_EVENT = 'wss:ignore:videoInfoEvent';
    _this.CURRENT_CHANNEL = 'epg:currentChannel';

    _this.INTERACTIVE_TYPES = ['vodChannel', 'dvrChannel'];

    //IE fix
    if (!_this.config && !_this.player) {
      _this.player = arguments[0];
      _this.config = arguments[1];
    }

    // if (!this.config.deviceID || this.config.deviceID.length < 1) {
    // 	//this.player.utils.log("MggpPluginWss: diviceID is not define");
    // 	return;
    // }

    _this.session = null;
    _this.interval = null;
    _this.last_state = null;
    _this.lastAction = null;
    _this.watchTimeAfterEvent = 0;
    _this.sessionPlayingTime = 0;
    _this.lastPosition = undefined;
    _this.videoEndedSent = false;
    _this.lastTimestamp = 0;
    _this.needToSendInit = false;
    _this.url = null;
    _this.videoInfo = null;
    _this.currentChannel = null;

    _this.p2pBytesReceived = 0;
    _this.cdnBytesReceived = 0;

    _this.player.registerProperty(_this.IGNORE_STOP_EVENT, false, true);
    _this.player.registerProperty(_this.IGNORE_VIDEOINFO_EVENT, false, true);

    _this.player.on('property:videoInfo', function (event) {
      _this._onVideoInfo(event);
    });

    _this.player.on('wss:p2pEvent', function (event) {
      var data = event.data;
      if (data) {
        switch (data.type) {
          case 'p2pReceived':
            _this.p2pBytesReceived += data.value;
            break;
          case 'cdnReceived':
            _this.cdnBytesReceived += data.value;
            break;
        }
      }
    });

    _this.player.on('property:state', function (event) {

      var state = event.data;
      if (_this.last_state === 2 && state !== 1) return;

      if (state === 1) {
        if (_this.needToSendInit) {
          _this.needToSendInit = false;

          if (_this.isURLValid(_this.url)) {

            _this.loadData(_this.url, function (session) {
              _this.lastAction = "start";
              _this.session = session;
              if (_this.session.session_id) _this.player.set('wss:sessionId', _this.session.session_id);
              _this.interval = setInterval(function () {

                if (!_this.session) {
                  clearInterval(_this.interval);
                  return;
                }

                var newTimestamp = Math.floor(new Date().getTime() / 1000);
                if (_this.player.get('state') === 1) {

                  if (_this.lastTimestamp) {
                    _this.watchTimeAfterEvent += newTimestamp - _this.lastTimestamp;
                  }
                  if (_this.watchTimeAfterEvent >= _this.session.call_interval) {
                    _this.trackAction('play');
                    _this.watchTimeAfterEvent = 0;
                  }
                }
                _this.lastTimestamp = newTimestamp;
              }, 100);
            });
          }
        } else if (_this.last_state === 2) {
          _this.trackAction('start');
          _this.watchTimeAfterEvent = 0;
        }
      } else if (state === 2) {
        _this.trackAction('stop');
      } else if (state === 0) {
        _this._processStopEvent();
      }

      _this.last_state = state;
    });

    _this.player.on('property:position', function (event) {
      if (event.data > 0 && _this.player.get('state') === 1) {
        var delta = event.data - _this.lastPosition;

        if (delta > 0 && delta < 2) _this.sessionPlayingTime += delta; // 100 ms timer

        _this.lastPosition = event.data;
      }
    });

    _this.player.on('player:stop', function (event) {
      _this._processStopEvent();
    });

    if (window && window.addEventListener) window.addEventListener('beforeunload', function (event) {
      _this._processStopEvent();
    });
    return _this;
  }

  _createClass(MggpPluginWss, [{
    key: '_processStopEvent',
    value: function _processStopEvent() {
      if (this.player.get(this.IGNORE_STOP_EVENT)) {
        this.player.set(this.IGNORE_STOP_EVENT, false);
        return;
      }

      if (!this.videoEndedSent && this.lastAction) {
        this.videoEndedSent = true;
        this.trackAction('stop');
        clearInterval(this.interval);
        this.session = null;

        this._resetPlugin();
      }
    }
  }, {
    key: '_resetPlugin',
    value: function _resetPlugin() {
      this.videoEndedSent = false;
      this.session = null;
      this.last_state = null;
      this.lastAction = null;
      this.watchTimeAfterEvent = 0;
      this.lastPosition = undefined;
      this.lastTimestamp = 0;
      this.p2pBytesReceived = 0;
      this.cdnBytesReceived = 0;
      this.needToSendInit = true;
    }

    /**
     * Handle initialization of new video
     * @param  {Object} event
     */

  }, {
    key: '_onVideoInfo',
    value: function _onVideoInfo(event) {
      this.currentChannel = this.player.get(this.CURRENT_CHANNEL);

      /*if (this.player.get(this.IGNORE_VIDEOINFO_EVENT)) {
        this.player.set(this.IGNORE_VIDEOINFO_EVENT, false);
        return;
      }*/

      var newVideoInfo = event.data;

      if (this.videoInfo && event.data && this.videoInfo.video_id === newVideoInfo.video_id && this.videoInfo.virtual_object_id === newVideoInfo.virtual_object_id) return;

      this.sessionPlayingTime = 0;

      var info = event.data;
      this.videoInfo = info;

      if (this.session && !this.videoEndedSent && this.lastAction) {
        this._processStopEvent();
      }
      this.url = null;
      this._resetPlugin();

      if (!info || !info.start_session_url) {
        return;
      }

      var url = '';
      if (info.start_session_url.indexOf('%user_id%') !== -1) {
        if (!this.config.deviceID || this.config.deviceID.length < 1) {
          return;
        } else {
          url = info.start_session_url.replace('%user_id%', this.config.deviceID);
        }
      } else {
        url = info.start_session_url;
      }

      var params = {};

      if (this.config.deviceOS) {
        params.d_os = this.config.deviceOS;
      }

      if (this.config.deviceType) {
        params.d_type = this.config.deviceType;
        try {
          if (this.config.device && this.config.device.device && (this.config.device.device.type === 'mobile' || this.config.device.device.type === 'tablet')) {
            params.d_type = this.config.deviceType + 'mobile';
          }
        } catch (error) {}
      }

      if (this.config.deviceModel) {
        params.d_model = this.config.deviceModel;
      }

      if (this.config.version) {
        params.d_app_version = this.config.version;
      }

      if (this.config.platformVersion) {
        params.platform_version = this.config.platformVersion.replace(/\s/g, '');
      }

      if (this.currentChannel && this.INTERACTIVE_TYPES.indexOf(this.currentChannel._type) !== -1) {
        params.track_history = 0; // to prevent writing watch history
      }

      params.v_screen_mode = this.isFullScreen();
      params.api = 'v2';

      url += url.indexOf('?') === -1 ? '?' : '&';
      url += Object.keys(params).map(function (key) {
        return key + '=' + params[key];
      }).join('&');

      this.url = url;

      clearInterval(this.interval);

      this.log('MggpPluginWss._onVideoInfo():InitURL=' + url + ', OS=' + params.d_os + ", Channel=" + params.d_channel_id + ', Type=' + params.d_type + ', Model=' + params.d_model + ', Version=' + params.d_app_version + ', Platform=' + params.platform_version);
    }

    /**
     * Send track event
     * @param  {string} action action type
     */

  }, {
    key: 'trackAction',
    value: function trackAction(action) {
      var _this2 = this;

      if (!this.session || !this.session[action] || this.lastAction === action && action !== 'play') {
        this.log('MggpPluginWss.abortAction: ' + action);
        return;
      }

      this.lastAction = action;

      var data = {};
      if (this.videoInfo && this.videoInfo.is_live) {
        data.v_timeline = 0;
      } else {
        data.v_timeline = this.lastPosition ? Math.round(this.lastPosition) : 0;
      }

      data.w_time = parseInt(this.sessionPlayingTime);
      data.v_screen_mode = this.isFullScreen();

      var url = this.session[action];
      url += url.indexOf('?') === -1 ? '?' : '&';
      url += Object.keys(data).map(function (key) {
        return key + '=' + data[key];
      }).join('&');

      if (action === 'play' && this.p2pBytesReceived > 0) {
        var cdnKBytes = Math.floor(this.cdnBytesReceived / 1048576 * 100) / 100;
        var p2pKBytes = Math.floor(this.p2pBytesReceived / 1048576 * 100) / 100;
        url += '&p2p_rcv=' + p2pKBytes + '&cdn_rcv=' + cdnKBytes;
      }

      if (!url) {
        url = '';
      }

      this.loadData(url, function (data) {
        if (_this2.session && data && data.session_id === _this2.session.session_id) _this2.session = data;
      });
    }

    /**
     * Start WSS session
     * @param  {string}   url      session URL
     * @param  {Function} callback
     */

  }, {
    key: 'loadData',
    value: function loadData(url, callback) {
      var _this3 = this;

      if (!url) {
        url = '';
      }

      this.log('MggpPluginWss.loadData()');
      var xhr = new XMLHttpRequest();
      try {
        xhr.open('GET', url, true);
        xhr.onreadystatechange = function () {
          if (xhr.readyState === 4 && xhr.status === 200) {
            var _res = null;

            try {
              _res = JSON.parse(xhr.responseText);
            } catch (e) {
              var errorType = _mggpPlayer.AddonError.errorTypes.PARSING_ERROR;
              var errorCode = _mggpPlayer.AddonError.errorCodes[errorType].PARSING_ERROR;
              var errorMessage = _mggpPlayer.AddonError.errorMessages['cannotParse'] + url;

              return new _mggpPlayer.AddonError(_this3.player, errorType, errorCode, errorMessage, false);
            }

            if (_res.result === 'ERROR') {
              return _this3.log('MggpPluginWss.loadData():' + _res.message);
            }

            if (_res.result === 'OK') {
              return callback(_res.data);
            }

            _this3._error('Invalid response');
          }
        };
        xhr.send();
      } catch (error) {
        this.log('MggpPluginWss.loadData():' + res.message);
      }
    }
  }, {
    key: 'isURLValid',
    value: function isURLValid(url) {
      var result = false;
      var reg = /http[s]?:\/\//;
      if (url && typeof url === 'string') {
        url = url.replace(reg, '');
        result = url && url[0] !== '?' && url[0] !== '&';
      }
      return result;
    }
  }, {
    key: 'isFullScreen',
    value: function isFullScreen() {
      if (this.player.config.deviceType === 'tv') {
        return 'fullscreen';
      }
      var result = 'notFullscreen';

      if (this.player.config.deviceOS.toLowerCase().indexOf('ios') !== -1) {
        try {
          var video = document.querySelector('#mggp-video-container video');
          if (video) {
            result = video.webkitDisplayingFullscreen ? 'fullscreen' : 'notfullscreen';
          }
        } catch (error) {}
      } else {
        var fullscreenElement = document.fullscreenElement || document.msFullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement;
        result = fullscreenElement ? 'fullscreen' : 'notfullscreen';
      }
      return result;
    }
  }]);

  return MggpPluginWss;
}(_mggpPlayer.Plugin);

exports.default = MggpPluginWss;

/***/ }),

/***/ "mggp-player":
/*!******************************!*\
  !*** external "mggp-player" ***!
  \******************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_mggp_player__;

/***/ })

/******/ });
});